import api from 'service/api'

const dponetAPI = api.create('supplierPortal')

const get = async ({ companySupplierQuestionnaireId, id = '' }) => {
  return await dponetAPI.get(
    `/company_supplier_questionnaires/${companySupplierQuestionnaireId}/quiz_question_templates/${id}`,
  )
}

export default { get }
